import type { TranslationValues } from "@llmgateway/i18n";

type Translator = (key: string, values?: TranslationValues) => string;

const providerCopyIds: Record<string, string> = {
	"inference.net": "inference-net",
};

export function getProviderCopyId(providerId: string): string {
	return providerCopyIds[providerId] ?? providerId;
}

export function getLocalizedProviderDescription(
	providerId: string,
	fallback: string | null | undefined,
	t: Translator,
): string {
	const key = `public.providers.descriptions.${getProviderCopyId(providerId)}`;
	const localized = t(key);

	return localized === key ? (fallback ?? "") : localized;
}
